import { fOrdinal } from '@aibees/shared/utils';
import { useMemo } from 'react';

export const useNextEntryLabel = (entriesCount: number): string => {
  return useMemo(() => {
    const entryNumber = entriesCount + 1;
    return `${fOrdinal(entryNumber)} Entry`;
  }, [entriesCount]);
};
